import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function popyp() {
  const tabs = [
    { title: 'Parent Orientation to PYP ', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Parent Orientation to PYP</h1>
    </div>
    <div class="pyppoisec">
    <p>Parent Orientation is an introductory session for parents/guardians of students enrolled in our school. The orientation aims to:</p>
    <br/>
    <p><b>Objectives:</b></p>
    <ol class="admission-class" typeof="i">
      <li>Introduce the IB PYP framework, philosophy, and curriculum.</li>
      <li>Explain the programme's teaching and learning approaches.</li>
      <li>Emphasize parental involvement and support.</li>
      <li>Address frequently asked questions.</li>
      </ol>
      <br/>
      <p>The process is beneficial for parent's understanding of the IB PYP curriculum and approach. The parents will come to know how to support their child's learning.</p>
      <p>By attending the IB PYP Parent Orientation, parents/guardians will gain a deeper understanding of the programme, enabling them to better support their child's educational journey.</p>


      </div>
      <div className="poppoisecPhoto">
        <div className='pop-photo-box'>
          <img src="../img/pyppoi/pypoi1.webp"></img>
        </div>
        <div className='pop-photo-box'>
          <img src="../img/pyppoi/pypoi2.webp"></img>
        </div>
        <div className='pop-photo-box'>
          <img src="../img/pyppoi/pypoi3.webp"></img>
        </div>
        <div className='pop-photo-box'>
          <img src="../img/pyppoi/pypoi4.webp"></img>
        </div>
        <div className='pop-photo-box'>
          <img src="../img/pyppoi/pypoi5.webp"></img>
        </div>
        <div className='pop-photo-box'>
          <img src="../img/pyppoi/pypoi6.webp"></img>
        </div>

      </div>


    </div> },


  ];
  return (
    <div>
      <div className='ibdp-hero-sec'>
        <img src='../newimg/pyppoi1.webp'/>

      </div>
    <div className='ib-syllabus'>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default popyp
